// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f2e5199d","501":"9e5bf42c"}[chunkId] + ".chunk.js";
};